<ng-content></ng-content>
<div #resizeElem class="grid-item-resize-icon"></div>